export default {
    book: 'Boek {product}',
    age_limit: 'Alleen voor {age}+',
    change_plan: 'Plan wijzigen',
    upgrade_product: 'Product upgraden',
    upgrade: 'Upgraden',
    cancel_upgrade: 'Upgrade annuleren',
    choose_product: 'Kies {product}',
    days: '{count} dag | {count} dagen',
    login_register: 'Inloggen/Registreren',
    current: 'Huidig',
    keyless_benefits: {
        label: 'Direct naar auto {0}',
        highlight: 'huurservice™',
        list: {
            cant_lose_the_key: 'Volledige verzekering',
            zero_excess: 'Geen eigen risico',
            phone_as_a_key: 'Telefoon als sleutel',
            straight_to_car: 'Geen wachttijd',
            no_queues: 'Geen wachtrijen',
            online_id_check: 'Online ID-controle',
            self_checkout: 'Zelf inchecken',
        },
    },
};
